import { Reducer } from 'redux';
import { IAgenciesState, AgencyActionTypes } from './types';
import { toast } from 'react-toastify';

const initialState: IAgenciesState = {
  currentAgency: { displayName: '', type: 'other', id: '' },
  list: [],
  mappedAgentAliases: { numberOfItems: 0, items: [] },
};

const reducer: Reducer<IAgenciesState> = (state = initialState, action) => {
  switch (action.type) {
    case AgencyActionTypes.GET_AGENCY_BY_ID_SUCCESS: {
      return {
        ...state,
        currentAgency: action.payload,
      };
    }
    case AgencyActionTypes.GET_AGENCY_BY_ID_FAILURE: {
      toast.error(`Failed to get agency details: ${action.payload}`);
      return state;
    }
    case AgencyActionTypes.GET_AGENCIES_SUCCESS: {
      return {
        ...state,
        list: [...action.payload],
      };
    }
    case AgencyActionTypes.GET_AGENT_ALIASES_SUCCESS: {
      return {
        ...state,
        mappedAgentAliases: action.payload,
      };
    }
    default:
      return state;
  }
};

export { reducer as agencyReducer };
